import { defineMessages } from 'react-intl';

export const freightQuoteModalMessages = defineMessages({
  title: {
    id: 'A4XCG+',
    description: 'Freight quote modal title',
    defaultMessage: 'Freight Rate Browser',
  },
  createShipmentTitle: {
    id: 'OrMtJK',
    description: 'Create Freight Shipment modal title in accordion wizard',
    defaultMessage: 'Create Freight Shipment',
  },
  closeAriaLabel: {
    id: 'PUELnT',
    description: 'Aria label for close button on freight quote drawer',
    defaultMessage: 'Close freight rate browser',
  },
  cancelButton: {
    id: 'RbCErS',
    description: 'Cancel button label in freight shipment modal footer',
    defaultMessage: 'Cancel',
  },
  saveDraftButton: {
    id: 'Dnd5ox',
    description: 'Save Draft button label in freight shipment modal footer',
    defaultMessage: 'Save Draft',
  },
  bookShipmentButton: {
    id: 'loLocx',
    description: 'Book Shipment button label in freight shipment modal footer',
    defaultMessage: 'Book Shipment',
  },
  quoteResultsPlaceholder: {
    id: 'wIHgl1',
    description: 'Placeholder text for quote results panel',
    defaultMessage: 'Quote Results',
  },
  bookedStatus: {
    id: 'mgFoev',
    description: 'Status badge text for a booked freight shipment in confirmation nav bar',
    defaultMessage: 'Booked',
  },
  printBolButton: {
    id: 'o/keFT',
    description: 'Print BOL button label in booking confirmation nav bar',
    defaultMessage: 'Print BOL',
  },
  trackButton: {
    id: 'cnMb/q',
    description: 'Track button label in booking confirmation nav bar',
    defaultMessage: 'Track',
  },
  closeConfirmationAriaLabel: {
    id: 'mS+Un7',
    description: 'Aria label for close button on booking confirmation drawer',
    defaultMessage: 'Close booking confirmation',
  },
});
